var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { initialState } from './initialState';
import { ACTION_PRICE_EXPLORER_GRID as actionTypes } from '../utils/constants';
import { createHeadersPerSku, isEmptyArray, capitalize } from '../utils/utils';
export default function (state, action) {
  if (state === void 0) {
    state = initialState.priceExplorerGrid;
  }

  switch (action.type) {
    case actionTypes.SET_SELLERS:
      {
        var sellers = action.payload;
        return __assign(__assign({}, state), {
          sellers: sellers
        });
      }

    case actionTypes.SET_MERCHANTS:
      {
        var merchants = action.payload;
        return __assign(__assign({}, state), {
          merchants: merchants
        });
      }

    case actionTypes.SET_PRICE_CONFIGURATIONS:
      {
        var priceConfigurations = action.payload;
        return __assign(__assign({}, state), {
          priceConfigurations: priceConfigurations
        });
      }

    case actionTypes.SET_PRICING_MODE:
      {
        var pricingVersion = action.payload;
        return __assign(__assign({}, state), {
          pricingVersion: pricingVersion
        });
      }

    case actionTypes.SET_ACCOUNT_MAP:
      {
        var accountMap = action.payload;
        return __assign(__assign({}, state), {
          accountMap: accountMap
        });
      }

    case actionTypes.SAVE_USER_PERMISSION_FULFILLER:
      {
        return __assign(__assign({}, state), {
          hasPermissionForFulfiller: action.payload
        });
      }

    case actionTypes.SET_ROW_DATA_BY_RESULTS:
      {
        var rowData = action.payload || null;
        return __assign(__assign({}, state), {
          rowData: rowData
        });
      }

    case actionTypes.SET_GRID_HEADERS:
      {
        return __assign(__assign({}, state), {
          headers: action.payload
        });
      }

    case actionTypes.SET_IS_LOADING_EQUIVALENCIES:
      {
        return __assign(__assign({}, state), {
          isLoadingEquivalencies: action.payload
        });
      }

    case actionTypes.SET_ROW_DATA_BY_PRICE_MODE:
      {
        var rowData = state.rowData;
        var priceMode_1 = action.payload;

        if (rowData) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          var spliceRowData = rowData.splice(0);
          var newRowData = spliceRowData.map(function (row) {
            Object.entries(row).forEach(function (_a) {
              var _b = __read(_a, 2),
                  key = _b[0],
                  value = _b[1];

              if (value && typeof value === 'object') {
                var productPrice = value.productPrice,
                    quantity = value.quantity;
                var displayPrice = productPrice.totalPrice;

                if (priceMode_1 === 'unit') {
                  displayPrice = productPrice.totalPrice / parseInt(quantity, 10);
                } // eslint-disable-next-line no-param-reassign


                value.productPrice = __assign(__assign({}, productPrice), {
                  displayPrice: displayPrice
                });
              }
            });
            return row;
          });
          return __assign(__assign({}, state), {
            rowData: newRowData
          });
        }

        return state;
      }

    case actionTypes.CREATE_COMPETITIVE_HEADERS:
      {
        var contractsPerSku = state.contractsPerSku,
            catalogPriceModelsPerSku = state.catalogPriceModelsPerSku,
            sellers = state.sellers,
            merchants = state.merchants,
            manufacturingCostModelsPerSku = state.manufacturingCostModelsPerSku,
            pricingVersion = state.pricingVersion,
            priceConfigurations = state.priceConfigurations,
            accountMap = state.accountMap;
        var _a = action.payload,
            competitors = _a.competitors,
            skuData = _a.skuData,
            showCompetitivePricing = _a.showCompetitivePricing;
        var skuList = Object.keys(skuData);
        var sku = skuList[0];
        var headers = {
          headerList: []
        };
        var _b = skuData[sku],
            selectedRow = _b.selectedRow,
            selectedColumn = _b.selectedColumn,
            sellerId = _b.sellerId;

        if (!headers.pinned && selectedRow) {
          var key = selectedRow.key;
          key = capitalize(key);
          headers.pinned = {
            name: key,
            value: key
          };
        }

        var skuChildren = createHeadersPerSku(selectedRow, selectedColumn, skuList[0], contractsPerSku, catalogPriceModelsPerSku, manufacturingCostModelsPerSku, sellers, showCompetitivePricing, null, sellerId, merchants, pricingVersion, priceConfigurations, accountMap);
        headers.headerList.push({
          name: sku,
          value: sku,
          isParent: true,
          children: skuChildren
        });
        var competitorChildren_1 = [];
        competitors.forEach(function (competitor) {
          competitorChildren_1.push({
            name: competitor.competitorName,
            value: competitor.normalizationId + "|" + competitor.competitorName,
            isParent: false
          });
        });
        headers.headerList.push({
          name: 'Competitors',
          value: 'Competitors',
          isParent: true,
          children: competitorChildren_1
        });
        return __assign(__assign({}, state), {
          headers: headers
        });
      }

    case actionTypes.CREATE_HEADERS:
      {
        var contractsPerSku_1 = state.contractsPerSku,
            catalogPriceModelsPerSku_1 = state.catalogPriceModelsPerSku,
            sellers_1 = state.sellers,
            merchants_1 = state.merchants,
            manufacturingCostModelsPerSku_1 = state.manufacturingCostModelsPerSku,
            pricingVersion_1 = state.pricingVersion,
            priceConfigurations_1 = state.priceConfigurations,
            accountMap_1 = state.accountMap;
        var _c = action.payload,
            skuData_1 = _c.skuData,
            isSingleSkuEnvironment = _c.isSingleSkuEnvironment,
            showCompetitivePricing_1 = _c.showCompetitivePricing,
            productPriceContractsInfo_1 = _c.productPriceContractsInfo;
        var skuList = Object.keys(skuData_1);
        var headers_1 = isSingleSkuEnvironment ? {
          headerList: []
        } : {
          headerList: {}
        };

        if (isSingleSkuEnvironment) {
          var sku = skuList[0];

          if (skuData_1[sku]) {
            var _d = skuData_1[sku],
                selectedRow = _d.selectedRow,
                selectedColumn = _d.selectedColumn,
                sellerId = _d.sellerId;
            headers_1 = createHeadersPerSku(selectedRow, selectedColumn, skuList[0], contractsPerSku_1, catalogPriceModelsPerSku_1, manufacturingCostModelsPerSku_1, sellers_1, showCompetitivePricing_1, productPriceContractsInfo_1, sellerId, merchants_1, pricingVersion_1, priceConfigurations_1, accountMap_1);
          }
        } else {
          skuList.forEach(function (sku) {
            if (skuData_1[sku]) {
              var _a = skuData_1[sku],
                  selectedRow = _a.selectedRow,
                  selectedColumn = _a.selectedColumn,
                  sellerId = _a.sellerId;

              if (!headers_1.pinned && selectedRow) {
                var key = capitalize(selectedRow.key);
                headers_1.pinned = {
                  name: key,
                  value: key
                };
              }

              var subHeaders = createHeadersPerSku(selectedRow, selectedColumn, sku, contractsPerSku_1, catalogPriceModelsPerSku_1, manufacturingCostModelsPerSku_1, sellers_1, showCompetitivePricing_1, productPriceContractsInfo_1, sellerId, merchants_1, pricingVersion_1, priceConfigurations_1, accountMap_1);
              headers_1.headerList[sku] = subHeaders.headerList;
            }
          });
        }

        return __assign(__assign({}, state), {
          headers: headers_1
        });
      }

    case actionTypes.ADD_ERROR_MESSAGES_TO_HEADERS:
      {
        var headers = state.headers;
        var _e = action.payload,
            errorType_1 = _e.errorType,
            errorMessage_1 = _e.errorMessage,
            sku = _e.sku;
        var newHeaders = Object.assign({}, headers);

        if (newHeaders) {
          var headerList = newHeaders.headerList ? newHeaders.headerList[sku] || newHeaders.headerList : headers;

          if (!isEmptyArray(headerList)) {
            headerList.forEach(function (header) {
              // eslint-disable-next-line no-param-reassign
              header.errorType = errorType_1; // eslint-disable-next-line no-param-reassign

              header.errorMessage = errorMessage_1;
            });
          }
        }

        return __assign(__assign({}, state), {
          headers: newHeaders
        });
      }

    case actionTypes.SET_CANCELABLE_PROMISE:
      {
        var cancelablePricingPromise = state.cancelablePricingPromise;
        var passedCancelablePromise = action.payload;

        if (!passedCancelablePromise && cancelablePricingPromise) {
          cancelablePricingPromise.cancel();
          return __assign(__assign({}, state), {
            cancelablePricingPromise: null
          });
        }

        return __assign(__assign({}, state), {
          cancelablePricingPromise: passedCancelablePromise
        });
      }

    case actionTypes.SET_PRICE_MODEL_INFO:
      {
        var _f = action.payload,
            contracts = _f.contracts,
            catalogPriceModels = _f.catalogPriceModels,
            manufacturingCostModels = _f.manufacturingCostModels;
        return __assign(__assign({}, state), {
          contractsPerSku: contracts,
          catalogPriceModelsPerSku: catalogPriceModels,
          manufacturingCostModelsPerSku: manufacturingCostModels
        });
      }

    case actionTypes.SAVE_RULE_SET_INFO:
      {
        return __assign(__assign({}, state), {
          ruleSetInfoPerSku: action.payload
        });
      }

    case actionTypes.ADD_SHIPPING_DATA_TO_ROW_DATA:
      {
        var _g = action.payload,
            sku = _g.sku,
            skuData = _g.skuData,
            shippingResult_1 = _g.shippingResult,
            finalRowData = _g.finalRowData;
        var rowData = finalRowData;
        var selectedRow = skuData[sku].selectedRow;
        var key_1 = selectedRow ? capitalize(selectedRow.key) : null;

        if (key_1 && rowData) {
          rowData.forEach(function (row) {
            var singlePivotValue = row[key_1];
            var baseShippingKey = key_1 + "|" + singlePivotValue;
            Object.keys(row).forEach(function (objectKey) {
              if (objectKey !== key_1) {
                var arrayOfKeys = objectKey.split('|');

                var _a = __read(arrayOfKeys, 4),
                    typeOfContract = _a[1],
                    contractName = _a[2],
                    dualPivotKey = _a[3];

                var shippingKey = contractName + "||" + baseShippingKey + "||"; // If dual pivot mode, update shipping key

                shippingKey = dualPivotKey === '' ? shippingKey : shippingKey + dualPivotKey;
                shippingKey = shippingKey.toLowerCase();
                var shippingData = null;

                if (typeOfContract === 'Contracts') {
                  shippingData = shippingResult_1.shippingContracts;
                } else if (typeOfContract === 'Catalog Price') {
                  shippingData = shippingResult_1.shippingCatalog;
                } else {
                  shippingData = shippingResult_1.shippingManufacturing;
                } // const shippingData = typeOfContract === 'Contracts' ? shippingResult.shippingContracts : shippingResult.shippingCatalog;


                row[objectKey].shippingPrice = shippingData && shippingData[shippingKey] && shippingData[shippingKey].price ? shippingData[shippingKey].price : null;
                row[objectKey].shippingErrorMessage = shippingData && shippingData[shippingKey] && shippingData[shippingKey].error ? shippingData[shippingKey].error : null;
              }
            });
          });
        }

        return __assign(__assign({}, state), {
          rowData: rowData
        });
      }

    case actionTypes.SAVE_LOGGED_SKU:
      {
        return __assign(__assign({}, state), {
          loggedSKU: action.payload
        });
      }

    default:
      return state;
  }
}